<template>
  <div class="registerwrap">
    <div class="loginWrap clearfix">
      <div class="loginLeft fl">
        <img class="bg1" src="~img/account/bg1.png" alt="" />
        <img
          @click="gohome"
          class="logotop"
          src="~img/account/logotop.png"
          alt=""
        />
        <div class="logoInfo">
          <img src="~img/account/email.png" alt="" />
          <p>kefu@yuanshixx.com</p>
          <img src="~img/account/phone2.png" alt="" />
          <p>010-82156292</p>
          <img src="~img/account/qq2.png" alt="" />
          <p>2984543729 / 2814551419</p>
        </div>
      </div>
      <div class="loginRight fl">
        <img class="bg2" src="~img/account/bg2.png" alt="" />
        <el-form
          ref="bindForm"
          class="loginall"
          :model="bindDate"
          :rules="rules"
          style="height:470px"
        >
          <h2>验证码登录</h2>
          <el-form-item prop="mobile">
            <el-input
              @focus="getFocus('bindForm', 'mobile')"
              v-model="bindDate.mobile"
              placeholder="手机号"
              class="login-form-input"
            ></el-input>
          </el-form-item>
          <el-form-item prop="imgCode">
            <el-input
              placeholder="请输入右侧验证码"
              @focus="getFocus('bindForm', 'imgCode')"
              v-model="bindDate.imgCode"
            >
              <template slot="append"
                ><img ref="codeimg" :src="imgcode" @click="getImgCode" alt=""
              /></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="getcodebox">
              <el-input
                @focus="getFocus('bindForm', 'code')"
                placeholder="获取验证码"
                v-model="bindDate.code"
                class="getcode"
              >
              </el-input>
              <div class="getmycode" v-show="isclick" @click="getCode">
                获取
              </div>
              <div
                class="getmycode isnoneclick"
                v-show="!isclick"
                width="117px"
              >
                重新发送 ({{ timecount }}s)
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="usersub" @click="bindMobile('bindForm')"
              >登录</el-button
            >
          </el-form-item>
          <loginelse></loginelse>
        </el-form>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { isMobile, encryptStr } from "utils/core/kernel";
import { BENDI } from "apiurl/index";
import { getCode, phonelogin } from "apiurl/login";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };
    return {
      bindDate: {
        mobile: "",
        imgCode: null,
        code: null
      },
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        imgCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      imgcode: "", //图片验证码
      timestamp: null, // 保存时间戳
      isclick: true, //是否可发送验证码
      timecount: 60, //倒计时秒数
      timer: null //计时对象
    };
  },
  created() {
    this.$nextTick(() => {
      /* 获取验证码 */
      this.getImgCode();
    });
  },
  methods: {
    /* 获取图片验证码 */
    getImgCode() {
      let timestamp = new Date().getTime();
      this.timestamp = timestamp;
      this.$refs.codeimg.setAttribute(
        "src",
        `${BENDI}/auth/image/captcha?timestamp=${timestamp}`
      );
    },
    /* 获取手机验证码 */
    async getCode() {
      if (this.bindDate.mobile && this.bindDate.imgCode) {
        let coderes = await getCode({
          mobile: encryptStr(this.bindDate.mobile),
          captcha: this.bindDate.imgCode,
          timestamp: this.timestamp
        });
        if (coderes.success) {
          this.$message({
            message: "短信已发送到您的手机！",
            type: "success"
          });
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.timecount = TIME_COUNT;
            this.isclick = false;
            this.timer = setInterval(() => {
              if (this.timecount > 1 && this.timecount <= TIME_COUNT) {
                this.timecount--;
              } else {
                this.isclick = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          //   this.$message.error(coderes.message);
          /* 再次点击刷新图片验证码 */
          if (coderes.code === 20004) {
            this.getImgCode();
          }
        }
      } else {
        this.$message.error("请输入手机号和图片验证码");
      }
    },
    /* 手机号绑定 */
    bindMobile(bindForm) {
      this.$refs[bindForm].validate(valid => {
        if (valid) {
          phonelogin({
            code: this.bindDate.code,
            account: encryptStr(this.bindDate.mobile)
          })
            .then(res => {
              if (res.success) {
                this.$message({
                  message: "登录成功",
                  type: "success"
                });
                this.$store.dispatch("saveInfo", res.data);
                if (this.$route.query.redirect) {
                  this.$router.replace(this.$route.query.redirect);
                } else {
                  this.$router.replace("/home");
                }
              } else {
                if (res.code == 20001) {
                  this.$router.replace("/home");
                }
              }
            })
            .catch(() => {});
        }
      });
    },
    // 移除
    getFocus(form, item) {
      this.$refs[form].clearValidate(item);
    },
    // 去首页
    gohome() {
      this.$router.push("/home");
    }
  },
  mounted() {}
};
</script>
<style>
.el-input-group__append img {
  display: block;
  width: 80px;
  height: 45px;
  border-radius: 0 4px 4px 0;
}
.getcode .el-input-group__append {
  background: rgba(72, 162, 223, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
}
.getcodebox {
  position: relative;
}
.getmycode {
  position: absolute;
  cursor: pointer;
  width: 80px;
  height: 46px;
  background: rgba(72, 162, 223, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
  top: 0px;
  right: 0px;
  text-align: center;
  line-height: 46px;
  border-radius: 0 4px 4px 0;
}
.isnoneclick {
  width: 117px;
}
</style>

<style lang="stylus" scoped>
.el-form
    width 300px
    margin 60px auto 0
    .goelse
        color #48A2DF
        a
            font-size 14px
            color #48A2DF
    .loginelse
        margin-top 40px
        display flex
        justify-content space-between
        a
            width 42px
            height 42px
</style>
